import React from "react";
import { Navigate } from "react-router-dom";
export default function Waitlist() {
  return <Navigate to="/community" replace />;
}
